/* Shop filter.

   Single-select: picking a type shows that type and only that type. Picking
   the one already showing goes back to everything, which is also the state the
   page loads in, so the grouped grid is what you get before touching anything.

   Filtering hides cards rather than rebuilding the grid. The markup is already
   in the right order from Liquid, so hiding is enough to leave the survivors
   correctly grouped, and nothing has to be re-sorted or re-fetched. */
(function () {
  'use strict';

  function setup(root) {
    var bar = root.querySelector('[data-vox-filter-bar]');
    var grid = root.querySelector('[data-vox-grid]');
    if (!bar || !grid) return;

    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-vox-filter]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-vox-type]'));
    var labels = Array.prototype.slice.call(grid.querySelectorAll('[data-vox-label]'));
    var counter = root.querySelector('[data-vox-count]');

    /* '' means everything */
    var active = readFromUrl();
    apply();

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var type = chip.getAttribute('data-vox-filter');

        /* tapping the type that is already showing clears back to everything */
        active = (!type || type === active) ? '' : type;

        apply();
        writeToUrl();
      });
    });

    function isOn(type) {
      return active === '' || type === active;
    }

    function apply() {
      var shown = 0;

      cards.forEach(function (card) {
        var on = isOn(card.getAttribute('data-vox-type'));
        card.hidden = !on;
        if (on) shown++;
      });

      /* a type heading is meaningless when its own cards are filtered out */
      labels.forEach(function (label) {
        label.hidden = !isOn(label.getAttribute('data-vox-label'));
      });

      chips.forEach(function (chip) {
        var type = chip.getAttribute('data-vox-filter');
        var on = type ? type === active : active === '';
        chip.classList.toggle('is-on', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (counter) counter.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    }

    /* the selection lives in the URL so a filtered view can be linked, shared,
       and survives the back button after someone opens a product */
    function readFromUrl() {
      try {
        var raw = new URLSearchParams(window.location.search).get('type');
        if (!raw) return '';
        /* older shared links carried a comma-separated list; take the first */
        var first = raw.split(',')[0];
        var known = chips.map(function (c) { return c.getAttribute('data-vox-filter'); });
        return known.indexOf(first) > -1 ? first : '';
      } catch (e) {
        return '';
      }
    }

    function writeToUrl() {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (active) {
          url.searchParams.set('type', active);
        } else {
          url.searchParams.delete('type');
        }
        window.history.replaceState({}, '', url);
      } catch (e) {
        /* a browser without URL support just loses the shareable link */
      }
    }
  }

  function init() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-vox-shop]'))
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-bind when the section is redrawn in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-vox-shop]');
    if (root) setup(root);
  });
})();
